var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartcontract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 549.359,
    height: 420.341,
    viewBox: "0 0 549.359 420.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.h{fill:#d4ecff;}.b{fill:#207cb6;}.c{fill:#fff;}.d{fill:#34bef0;}.e{fill:#fafdff;}.f{fill:#132d58;}.g{fill:#396caa;}.h{opacity:0.4;}.i{fill:#5793ce;}.j{fill:#173d7a;}.k{fill:#abd6f4;}.l,.p{fill:#1d1d1d;}.l{opacity:0.2;}.m{fill:#bebebe;}.n{fill:#d8d8d8;}.o{fill:#e9e9e9;}.p{opacity:0.51;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1289 -264.361)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1397.686 264.361)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.059,283.994l78.745-44.9c2.88-1.663,2.519-4.567-.807-6.486l-45.307-26.159c-3.324-1.919-8.355-2.128-11.235-.465l-78.745,44.9c-2.88,1.663-2.519,4.568.807,6.488l45.307,26.158C324.15,285.448,329.179,285.657,332.059,283.994Z",
    transform: "translate(-267.672 0.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M269.364,295.417h0V111.583l73.083-19.129,13.461-7.772c3.089-1.784,8.485-1.56,12.052.5l12.559,7.251,38.981-.021L407.957,269.878a3.494,3.494,0,0,1-2.069,3.229l-72.933,55.03c-3.089,1.784-8.485,1.56-12.052-.5l-48.6-28.061C270.241,298.388,269.249,296.849,269.364,295.417Z",
    transform: "translate(-269.348 -58.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M342.674,83.485a13.91,13.91,0,0,1,6.461,1.694l12.559,7.251,38.981-.021V276.737a3.494,3.494,0,0,1-2.07,3.229L314.13,328.134a10.886,10.886,0,0,1-5.593,1.195l-.871-185.479Z",
    transform: "translate(-250.522 -58.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M314.655,309.347a13.733,13.733,0,0,1-9.634-.11V122.49h9.634Z",
    transform: "translate(-251.822 -39.812)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M332.958,151.945l84.475-48.168c3.09-1.784,2.7-4.9-.865-6.959l-48.6-28.061c-3.567-2.06-8.963-2.283-12.052-.5l-84.475,48.168c-3.09,1.784-2.7,4.9.865,6.959l48.6,28.061C324.474,153.505,329.87,153.729,332.958,151.945Z",
    transform: "translate(-269.35 -67.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M272.3,109.443,320.9,137.5c3.567,2.06,8.963,2.283,12.052.5L417.43,89.836a4.651,4.651,0,0,0,1.542-1.368c1.06,1.708.58,3.561-1.542,4.786l-84.475,48.168c-3.089,1.784-8.485,1.56-12.052-.5l-48.6-28.061c-2.771-1.6-3.614-3.837-2.407-5.591A6.759,6.759,0,0,0,272.3,109.443Z",
    transform: "translate(-269.348 -56.53)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.454 15.584)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M320.205,127.289l56.241-32.6c1.447-.834,1.265-2.292-.4-3.256L353.3,78.3a6.27,6.27,0,0,0-5.639-.234l-56.241,32.6c-1.447.834-1.265,2.292.4,3.256l22.744,13.132A6.274,6.274,0,0,0,320.205,127.289Z",
    transform: "translate(-290.44 -77.503)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.347 14.39)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.114,91.41l3.259-1.882c.2-.115.174-.316-.057-.45l-3.147-1.817a.866.866,0,0,0-.78-.031l-3.259,1.881c-.2.116-.175.318.055.45l3.147,1.817A.864.864,0,0,0,332.114,91.41Z",
    transform: "translate(-295.332 -87.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M324.813,95.609l3.26-1.882c.2-.115.174-.318-.057-.45l-3.147-1.817a.866.866,0,0,0-.78-.033l-3.259,1.882c-.2.115-.176.316.055.45l3.147,1.817A.871.871,0,0,0,324.813,95.609Z",
    transform: "translate(-298.92 -85.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M317.513,99.805l3.259-1.881c.2-.116.176-.318-.055-.45l-3.147-1.817a.864.864,0,0,0-.782-.033l-3.259,1.881c-.2.116-.174.318.057.452l3.147,1.817A.866.866,0,0,0,317.513,99.805Z",
    transform: "translate(-302.507 -83.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.213,104l3.259-1.881c.2-.116.174-.318-.057-.452l-3.147-1.817a.866.866,0,0,0-.78-.031l-3.259,1.881c-.2.116-.174.318.057.45l3.147,1.817A.861.861,0,0,0,310.213,104Z",
    transform: "translate(-306.095 -80.963)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.444,94.687l-.066.039a3.964,3.964,0,0,0-.339-.233L353.294,81.361a6.266,6.266,0,0,0-5.639-.233L291.48,113.691c-1.332-.953-1.4-2.252-.066-3.023l56.241-32.6a6.271,6.271,0,0,1,5.639.234l22.745,13.132C377.708,92.395,377.89,93.853,376.444,94.687Z",
    transform: "translate(-290.438 -77.503)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404.516 346.852)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M309.166,161.187l-31.977-18.309a7.8,7.8,0,0,1-3.259-6.225V125.218c0-2.4,1.459-3.5,3.259-2.464l31.977,18.309a7.806,7.806,0,0,1,3.257,6.225v11.436C312.423,161.123,310.965,162.226,309.166,161.187Z",
    transform: "translate(-273.93 -122.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M275.606,122.395a3.189,3.189,0,0,0-.819,2.379V136.21a7.8,7.8,0,0,0,3.259,6.225l31.976,18.309a2.354,2.354,0,0,0,1.584.345,1.946,1.946,0,0,1-2.441.084l-31.976-18.309a7.8,7.8,0,0,1-3.259-6.225V125.2C273.93,123.573,274.61,122.564,275.606,122.395Z",
    transform: "translate(-273.93 -122.349)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.165 13.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M292.308,142.308l-2.934-1.693a1.7,1.7,0,0,1-.71-1.357v-3.133c0-.523.318-.764.71-.537l2.934,1.693a1.7,1.7,0,0,1,.71,1.357v3.133C293.017,142.295,292.7,142.535,292.308,142.308Z",
    transform: "translate(-278.855 -129.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M285.73,138.511l-2.932-1.693a1.7,1.7,0,0,1-.711-1.357v-3.133c0-.523.319-.764.711-.537l2.932,1.693a1.7,1.7,0,0,1,.711,1.357v3.133C286.442,138.5,286.123,138.738,285.73,138.511Z",
    transform: "translate(-282.087 -131.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404.516 429.485)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M309.166,216.593l-31.977-18.307a7.8,7.8,0,0,1-3.259-6.227V180.625c0-2.4,1.459-3.5,3.259-2.464l31.977,18.309a7.806,7.806,0,0,1,3.257,6.225V214.13C312.423,216.53,310.965,217.632,309.166,216.593Z",
    transform: "translate(-273.93 -177.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M275.606,177.8a3.189,3.189,0,0,0-.819,2.379v11.436a7.8,7.8,0,0,0,3.259,6.225l31.976,18.309a2.345,2.345,0,0,0,1.584.344,1.944,1.944,0,0,1-2.441.084l-31.976-18.307a7.8,7.8,0,0,1-3.259-6.227V180.609C273.93,178.981,274.61,177.971,275.606,177.8Z",
    transform: "translate(-273.93 -177.755)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.165 13.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M292.308,197.714l-2.934-1.693a1.7,1.7,0,0,1-.71-1.357v-3.133c0-.523.318-.764.71-.537l2.934,1.694a1.7,1.7,0,0,1,.71,1.356v3.133C293.017,197.7,292.7,197.941,292.308,197.714Z",
    transform: "translate(-278.855 -185.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M285.73,193.917l-2.932-1.693a1.7,1.7,0,0,1-.711-1.357v-3.133c0-.524.319-.764.711-.537l2.932,1.694a1.7,1.7,0,0,1,.711,1.356v3.133C286.442,193.9,286.123,194.144,285.73,193.917Z",
    transform: "translate(-282.087 -187.112)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404.516 470.801)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M309.166,244.3l-31.977-18.307a7.8,7.8,0,0,1-3.259-6.227V208.327c0-2.4,1.459-3.5,3.259-2.464l31.977,18.309a7.806,7.806,0,0,1,3.257,6.225v11.436C312.423,244.233,310.965,245.335,309.166,244.3Z",
    transform: "translate(-273.93 -205.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M275.606,205.5a3.19,3.19,0,0,0-.819,2.38v11.435a7.8,7.8,0,0,0,3.259,6.225l31.976,18.308a2.345,2.345,0,0,0,1.584.345,1.944,1.944,0,0,1-2.441.084l-31.976-18.307a7.8,7.8,0,0,1-3.259-6.227V208.312C273.93,206.684,274.61,205.674,275.606,205.5Z",
    transform: "translate(-273.93 -205.458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.165 13.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M292.308,225.417l-2.934-1.693a1.7,1.7,0,0,1-.71-1.357v-3.133c0-.522.318-.764.71-.537l2.934,1.694a1.7,1.7,0,0,1,.71,1.357v3.132C293.017,225.4,292.7,225.644,292.308,225.417Z",
    transform: "translate(-278.855 -212.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M285.73,221.62l-2.932-1.693a1.7,1.7,0,0,1-.711-1.357v-3.133c0-.523.319-.764.711-.537l2.932,1.694a1.7,1.7,0,0,1,.711,1.356v3.133C286.442,221.607,286.123,221.847,285.73,221.62Z",
    transform: "translate(-282.087 -214.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404.516 388.168)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M309.166,188.89l-31.977-18.309a7.8,7.8,0,0,1-3.259-6.225V152.921c0-2.4,1.459-3.5,3.259-2.464l31.977,18.308a7.806,7.806,0,0,1,3.257,6.225v11.436C312.423,188.827,310.965,189.929,309.166,188.89Z",
    transform: "translate(-273.93 -150.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M275.606,150.1a3.189,3.189,0,0,0-.819,2.379v11.436a7.8,7.8,0,0,0,3.259,6.225l31.976,18.309a2.345,2.345,0,0,0,1.584.344,1.946,1.946,0,0,1-2.441.084l-31.976-18.309a7.8,7.8,0,0,1-3.259-6.225V152.906C273.93,151.278,274.61,150.268,275.606,150.1Z",
    transform: "translate(-273.93 -150.052)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.165 13.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M292.308,170.011l-2.934-1.693a1.7,1.7,0,0,1-.71-1.357v-3.133c0-.523.318-.764.71-.537l2.934,1.694a1.7,1.7,0,0,1,.71,1.356v3.133C293.017,170,292.7,170.238,292.308,170.011Z",
    transform: "translate(-278.855 -157.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M285.73,166.214l-2.932-1.693a1.7,1.7,0,0,1-.711-1.357v-3.133c0-.523.319-.764.711-.537l2.932,1.694a1.7,1.7,0,0,1,.711,1.356v3.133C286.442,166.2,286.123,166.441,285.73,166.214Z",
    transform: "translate(-282.087 -159.409)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 308.977)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.111,161.96l73.774-42.593a7.16,7.16,0,0,0,2.99-5.712V99.588c0-2.2-1.339-3.214-2.99-2.261L317.111,139.92a7.163,7.163,0,0,0-2.99,5.714V159.7C314.121,161.9,315.46,162.915,317.111,161.96Z",
    transform: "translate(-314.121 -96.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,155.345,387.584,115.2a3.635,3.635,0,0,0,1.517-2.9V101.723c0-1.117-.679-1.63-1.517-1.147l-69.538,40.149a3.63,3.63,0,0,0-1.517,2.9V154.2C316.529,155.315,317.208,155.828,318.046,155.345Z",
    transform: "translate(-312.938 -95.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,115.672l10.379-5.992a3.525,3.525,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,115.643,354.127,116.141,354.94,115.672Z",
    transform: "translate(-294.786 -92.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M348.526,115.5c0,1.084.761,1.524,1.7.981a3.759,3.759,0,0,0,1.7-2.946c0-1.086-.761-1.524-1.7-.983A3.759,3.759,0,0,0,348.526,115.5Z",
    transform: "translate(-297.214 -89.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M344.5,117.821c0,1.086.762,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.761,3.761,0,0,0,344.5,117.821Z",
    transform: "translate(-299.192 -88.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.479,120.144c0,1.086.762,1.524,1.7.983a3.761,3.761,0,0,0,1.7-2.947c0-1.084-.762-1.524-1.7-.981A3.763,3.763,0,0,0,340.479,120.144Z",
    transform: "translate(-301.168 -87.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M336.456,122.467c0,1.084.761,1.524,1.7.983a3.763,3.763,0,0,0,1.7-2.947c0-1.084-.762-1.524-1.7-.981A3.756,3.756,0,0,0,336.456,122.467Z",
    transform: "translate(-303.145 -86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M319.819,136.041l3.5-2.018a2.263,2.263,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.266,2.266,0,0,0-.946,1.806v3.7C318.873,136.024,319.3,136.343,319.819,136.041Z",
    transform: "translate(-311.786 -81.871)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 333.783)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.111,178.593,390.885,136a7.16,7.16,0,0,0,2.99-5.712V116.221c0-2.2-1.339-3.214-2.99-2.261l-73.774,42.593a7.161,7.161,0,0,0-2.99,5.714v14.067C314.121,178.535,315.46,179.548,317.111,178.593Z",
    transform: "translate(-314.121 -113.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,171.978l69.538-40.147a3.635,3.635,0,0,0,1.517-2.9V118.356c0-1.117-.679-1.63-1.517-1.147l-69.538,40.149a3.63,3.63,0,0,0-1.517,2.9v10.576C316.529,171.948,317.208,172.461,318.046,171.978Z",
    transform: "translate(-312.938 -111.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,132.3l10.379-5.992a3.527,3.527,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,132.275,354.127,132.774,354.94,132.3Z",
    transform: "translate(-294.786 -109.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.526,132.131c0,1.086.761,1.526,1.7.983a3.759,3.759,0,0,0,1.7-2.946c0-1.086-.761-1.524-1.7-.983A3.759,3.759,0,0,0,348.526,132.131Z",
    transform: "translate(-297.214 -106.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M344.5,134.454c0,1.086.762,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.76,3.76,0,0,0,344.5,134.454Z",
    transform: "translate(-299.192 -104.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.479,136.777c0,1.084.762,1.524,1.7.983a3.761,3.761,0,0,0,1.7-2.947c0-1.084-.762-1.524-1.7-.981A3.763,3.763,0,0,0,340.479,136.777Z",
    transform: "translate(-301.168 -103.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M336.456,139.1c0,1.084.761,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.946c0-1.084-.762-1.524-1.7-.981A3.756,3.756,0,0,0,336.456,139.1Z",
    transform: "translate(-303.145 -102.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M319.819,152.674l3.5-2.018a2.263,2.263,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.266,2.266,0,0,0-.946,1.806v3.7C318.873,152.657,319.3,152.976,319.819,152.674Z",
    transform: "translate(-311.786 -98.504)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 358.59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.111,195.226l73.774-42.593a7.16,7.16,0,0,0,2.99-5.712V132.854c0-2.2-1.339-3.214-2.99-2.261l-73.774,42.593a7.161,7.161,0,0,0-2.99,5.714v14.067C314.121,195.168,315.46,196.181,317.111,195.226Z",
    transform: "translate(-314.121 -130.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,188.611l69.538-40.147a3.635,3.635,0,0,0,1.517-2.9V134.989c0-1.117-.679-1.63-1.517-1.147l-69.538,40.149a3.63,3.63,0,0,0-1.517,2.9v10.576C316.529,188.581,317.208,189.094,318.046,188.611Z",
    transform: "translate(-312.938 -128.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,148.938l10.379-5.992a3.527,3.527,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,148.908,354.127,149.407,354.94,148.938Z",
    transform: "translate(-294.786 -126.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.526,148.764c0,1.086.761,1.526,1.7.983a3.759,3.759,0,0,0,1.7-2.946c0-1.086-.761-1.526-1.7-.983A3.759,3.759,0,0,0,348.526,148.764Z",
    transform: "translate(-297.214 -122.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M344.5,151.087c0,1.086.762,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.76,3.76,0,0,0,344.5,151.087Z",
    transform: "translate(-299.192 -121.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.479,153.41c0,1.084.762,1.524,1.7.983a3.761,3.761,0,0,0,1.7-2.947c0-1.084-.762-1.524-1.7-.981A3.763,3.763,0,0,0,340.479,153.41Z",
    transform: "translate(-301.168 -120.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M336.456,155.733c0,1.084.761,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.945c0-1.084-.762-1.524-1.7-.981A3.756,3.756,0,0,0,336.456,155.733Z",
    transform: "translate(-303.145 -119.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M319.819,169.307l3.5-2.018a2.263,2.263,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.264,2.264,0,0,0-.946,1.806v3.7C318.873,169.29,319.3,169.609,319.819,169.307Z",
    transform: "translate(-311.786 -115.137)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 383.396)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.111,211.859l73.774-42.593a7.16,7.16,0,0,0,2.99-5.712V149.487c0-2.2-1.339-3.214-2.99-2.261l-73.774,42.593a7.161,7.161,0,0,0-2.99,5.714V209.6C314.121,211.8,315.46,212.814,317.111,211.859Z",
    transform: "translate(-314.121 -146.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,205.244,387.584,165.1a3.635,3.635,0,0,0,1.517-2.9V151.622c0-1.117-.679-1.63-1.517-1.147l-69.538,40.149a3.63,3.63,0,0,0-1.517,2.9V204.1C316.529,205.214,317.208,205.727,318.046,205.244Z",
    transform: "translate(-312.938 -145.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,165.571l10.379-5.992a3.527,3.527,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,165.541,354.127,166.04,354.94,165.571Z",
    transform: "translate(-294.786 -142.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M348.526,165.4c0,1.086.761,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.946c0-1.086-.761-1.526-1.7-.983A3.759,3.759,0,0,0,348.526,165.4Z",
    transform: "translate(-297.214 -139.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M344.5,167.72c0,1.086.762,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.761,3.761,0,0,0,344.5,167.72Z",
    transform: "translate(-299.192 -138.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.479,170.043c0,1.084.762,1.524,1.7.983a3.761,3.761,0,0,0,1.7-2.947c0-1.084-.762-1.524-1.7-.981A3.761,3.761,0,0,0,340.479,170.043Z",
    transform: "translate(-301.168 -137.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M336.456,172.366c0,1.084.761,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.946c0-1.084-.762-1.524-1.7-.981A3.756,3.756,0,0,0,336.456,172.366Z",
    transform: "translate(-303.145 -135.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.819,185.94l3.5-2.018a2.263,2.263,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.263,2.263,0,0,0-.946,1.806v3.7C318.873,185.923,319.3,186.242,319.819,185.94Z",
    transform: "translate(-311.786 -131.77)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 408.203)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.111,228.492,390.885,185.9a7.16,7.16,0,0,0,2.99-5.712V166.12c0-2.2-1.339-3.214-2.99-2.261l-73.774,42.593a7.161,7.161,0,0,0-2.99,5.714v14.067C314.121,228.434,315.46,229.445,317.111,228.492Z",
    transform: "translate(-314.121 -163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,221.877l69.538-40.147a3.635,3.635,0,0,0,1.517-2.9V168.255c0-1.117-.679-1.63-1.517-1.147l-69.538,40.149a3.63,3.63,0,0,0-1.517,2.9V220.73C316.529,221.847,317.208,222.36,318.046,221.877Z",
    transform: "translate(-312.938 -161.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,182.2l10.379-5.992a3.527,3.527,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,182.174,354.127,182.673,354.94,182.2Z",
    transform: "translate(-294.786 -159.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M348.526,182.03c0,1.086.761,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.759,3.759,0,0,0,348.526,182.03Z",
    transform: "translate(-297.214 -155.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M344.5,184.353c0,1.086.762,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.76,3.76,0,0,0,344.5,184.353Z",
    transform: "translate(-299.192 -154.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.479,186.676c0,1.084.762,1.524,1.7.983a3.761,3.761,0,0,0,1.7-2.947c0-1.084-.762-1.524-1.7-.981A3.761,3.761,0,0,0,340.479,186.676Z",
    transform: "translate(-301.168 -153.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M336.456,189c0,1.084.761,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.946c0-1.084-.762-1.524-1.7-.981A3.756,3.756,0,0,0,336.456,189Z",
    transform: "translate(-303.145 -152.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.819,202.573l3.5-2.018a2.263,2.263,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.264,2.264,0,0,0-.946,1.806v3.7C318.873,202.555,319.3,202.875,319.819,202.573Z",
    transform: "translate(-311.786 -148.403)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 433.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M317.111,245.125l73.774-42.593a7.16,7.16,0,0,0,2.99-5.712V182.752c0-2.2-1.339-3.212-2.99-2.259l-73.774,42.593a7.16,7.16,0,0,0-2.99,5.712v14.068C314.121,245.067,315.46,246.078,317.111,245.125Z",
    transform: "translate(-314.121 -180.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,238.51l69.538-40.147a3.635,3.635,0,0,0,1.517-2.9V184.888c0-1.117-.679-1.63-1.517-1.147L318.046,223.89a3.63,3.63,0,0,0-1.517,2.9v10.576C316.529,238.48,317.208,238.993,318.046,238.51Z",
    transform: "translate(-312.938 -178.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,198.837l10.379-5.992a3.527,3.527,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,198.807,354.127,199.306,354.94,198.837Z",
    transform: "translate(-294.786 -175.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M348.526,198.663c0,1.086.761,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.759,3.759,0,0,0,348.526,198.663Z",
    transform: "translate(-297.214 -172.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M344.5,200.986c0,1.086.762,1.524,1.7.983a3.759,3.759,0,0,0,1.7-2.947c0-1.084-.761-1.524-1.7-.981A3.76,3.76,0,0,0,344.5,200.986Z",
    transform: "translate(-299.192 -171.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.479,203.309c0,1.084.762,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.946c0-1.084-.762-1.524-1.7-.981A3.761,3.761,0,0,0,340.479,203.309Z",
    transform: "translate(-301.168 -170.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M336.456,205.632c0,1.084.761,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.946c0-1.084-.762-1.524-1.7-.981A3.757,3.757,0,0,0,336.456,205.632Z",
    transform: "translate(-303.145 -169.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M319.819,219.206l3.5-2.018a2.263,2.263,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.263,2.263,0,0,0-.946,1.806v3.7C318.873,219.189,319.3,219.508,319.819,219.206Z",
    transform: "translate(-311.786 -165.036)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1464.458 457.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M317.111,261.758l73.774-42.593a7.16,7.16,0,0,0,2.99-5.712V199.385c0-2.2-1.339-3.213-2.99-2.259l-73.774,42.593a7.16,7.16,0,0,0-2.99,5.712V259.5C314.121,261.7,315.46,262.711,317.111,261.758Z",
    transform: "translate(-314.121 -196.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.046,255.143,387.584,215a3.635,3.635,0,0,0,1.517-2.9V201.521c0-1.117-.679-1.63-1.517-1.147l-69.538,40.149a3.63,3.63,0,0,0-1.517,2.9V254C316.529,255.113,317.208,255.626,318.046,255.143Z",
    transform: "translate(-312.938 -195.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.94,215.47l10.379-5.992a3.529,3.529,0,0,0,1.472-2.814h0c0-1.084-.659-1.582-1.472-1.113l-10.379,5.991a3.529,3.529,0,0,0-1.472,2.814h0C353.468,215.44,354.127,215.939,354.94,215.47Z",
    transform: "translate(-294.786 -192.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M347.254,217.128c0,2.048,1.438,2.878,3.212,1.854a7.1,7.1,0,0,0,3.213-5.564c0-2.049-1.438-2.878-3.213-1.855A7.1,7.1,0,0,0,347.254,217.128Z",
    transform: "translate(-297.839 -189.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M338.921,221.073c0,1.084.761,1.524,1.7.981a3.758,3.758,0,0,0,1.7-2.946c0-1.084-.762-1.524-1.7-.981A3.757,3.757,0,0,0,338.921,221.073Z",
    transform: "translate(-301.934 -186.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M334.9,223.4c0,1.084.762,1.524,1.7.981a3.759,3.759,0,0,0,1.7-2.946c0-1.084-.761-1.524-1.7-.983A3.761,3.761,0,0,0,334.9,223.4Z",
    transform: "translate(-303.912 -185.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M330.874,225.719c0,1.084.762,1.524,1.7.981a3.761,3.761,0,0,0,1.7-2.946c0-1.086-.762-1.524-1.7-.983A3.763,3.763,0,0,0,330.874,225.719Z",
    transform: "translate(-305.888 -184.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.819,235.839l3.5-2.018a2.266,2.266,0,0,0,.946-1.806v-3.7c0-.7-.424-1.016-.946-.714l-3.5,2.018a2.264,2.264,0,0,0-.946,1.806v3.7C318.873,235.822,319.3,236.141,319.819,235.839Z",
    transform: "translate(-311.786 -181.669)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M564.892,293.787,419.979,210.08l163.356,7.7,10.147,9.706,2.206,14.559-1.618,9.893-4.853,12.018-4.853,9.412-5.441,7.059Z",
    transform: "translate(1202.356 267.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M508.313,159.69c-.246-.152-.5-.3-.753-.434l-.045-.027h-.006c-5.79-3.1-13.652-2.534-22.309,2.464L287.254,275.976a13.893,13.893,0,0,1,2.277,2.215l7.5-4.331,40.056,87.047,20.735,28.308,13.53,4.707,13.564-5.3L450.766,351.2l130.513-74.627,47.867-28.754,12.5-3.97,11.245-.668Z",
    transform: "translate(1137.134 241.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M351.884,372.407c0-20.489,14.437-45.491,32.18-55.735V320.2c-16.058,9.272-29.123,31.9-29.123,50.442s13.065,26.085,29.123,16.814L630.113,245.4c8.869-5.12,16.911-5.6,22.738-2.24L508.313,159.69c-.246-.152-.5-.3-.753-.434l-.045-.027h-.006c-5.79-3.1-13.652-2.534-22.309,2.464L287.254,275.976a13.893,13.893,0,0,1,2.277,2.215l7.5-4.333,40.056,87.049,16.568,22.619A32.537,32.537,0,0,1,351.884,372.407Z",
    transform: "translate(1137.134 241.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M532.421,214.9h0l-.025-.015Z",
    transform: "translate(1257.599 269.951)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1424.388 480.735)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M330.589,310.415c0,.358.031.691.04,1.041.209-10.225,3.927-21.487,9.793-31.44-.274-.173-.549-.349-.82-.528C334.034,289.386,330.589,300.432,330.589,310.415Z",
    transform: "translate(-265.959 -179.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M607.811,216.505,361.762,358.562c-15.679,9.053-28.5,2.069-29.094-15.526,0,.222-.028.449-.028.67,0,18.543,13.065,26.085,29.123,16.814L607.811,218.462c8.869-5.12,16.911-5.6,22.738-2.24l-6.993-4.037C618.9,211.843,613.529,213.2,607.811,216.505Z",
    transform: "translate(-264.952 -212.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M337.091,321.2l-40.056-87.049-7.5,4.331c-.3-.358-.617-.7-.943-1.028l-1.335.771a13.894,13.894,0,0,1,2.277,2.215l7.5-4.333,40.056,87.049,16.568,22.619a26.907,26.907,0,0,1-.913-3.2Z",
    transform: "translate(-287.254 -201.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M532.421,213.583h0l-.025-.015Z",
    transform: "translate(-166.788 -211.429)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M265.6,208.039h0c-17.745,10.244-32.18,35.248-32.18,55.735,0,9.893,3.372,16.941,8.85,20.443l.007.01.087.051q.488.306,1,.576l144.386,83.431-8.841-15.979,1.029-15.955,2.795-8.971L387,317.821s3.53-6.544,3.751-6.69,5.22-6.619,5.22-6.619l4.86-5.072,5.287-3.383,4.4-4.31Z",
    transform: "translate(1110.682 266.589)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1489.018 482.682)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M608.818,292.136v-3.529c16.06-9.272,29.124-31.9,29.124-50.444s-13.065-26.085-29.124-16.813L362.769,363.407c-17.743,10.245-32.18,1.911-32.18-18.578s14.437-45.491,32.18-55.735v3.529c-16.058,9.272-29.123,31.9-29.123,50.442s13.065,26.085,29.123,16.814L608.818,217.822C626.563,207.576,641,215.91,641,236.4S626.563,281.892,608.818,292.136Z",
    transform: "translate(-330.589 -213.439)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M479.919,245.844l-68.909-38.9c-2.75-1.55-7.523-1.3-10.659.553l-39.375,23.285c-3.136,1.855-3.451,4.614-.7,6.165l68.908,38.9c2.75,1.55,7.524,1.3,10.661-.553l39.375-23.285C482.354,250.154,482.669,247.394,479.919,245.844Z",
    transform: "translate(1172.096 265.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M428.787,272.006,357.95,232.09a3.606,3.606,0,0,1-2.1-2.984l-.036.027-.081-7.888s2.489,2.042,3.952,3.239l44.14-26.1c3.591-2.125,9.054-2.409,12.2-.634L483.73,235.9l5.178-3.063L489,240.8l-.03-.025c-.019,1.365-.981,2.8-2.914,3.946L440.99,271.372C437.4,273.5,431.935,273.779,428.787,272.006Z",
    transform: "translate(1170.783 260.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M486.774,232.28l-70.837-39.916c-3.148-1.773-8.61-1.49-12.2.634l-45.069,26.651c-3.591,2.124-3.951,5.284-.8,7.057L428.7,266.622c3.148,1.775,8.611,1.49,12.2-.634l45.067-26.651C489.563,237.213,489.923,234.053,486.774,232.28Z",
    transform: "translate(1170.778 258.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M428.69,256.216,357.853,216.3c-1.79-1.008-2.407-2.465-1.979-3.924a4.265,4.265,0,0,0,1.82,1.828l70.839,39.915c3.147,1.775,8.61,1.49,12.2-.634L485.8,226.834a5.732,5.732,0,0,0,2.783-3.133c.817,1.688-.067,3.718-2.623,5.23l-45.067,26.651C437.3,257.707,431.839,257.991,428.69,256.216Z",
    transform: "translate(1170.79 268.72)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1571.74 473.671)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M397.554,213.971c2.608-1.542,2.582-4-.057-5.485a10.5,10.5,0,0,0-9.5.1c-2.608,1.542-2.583,4,.057,5.487A10.5,10.5,0,0,0,397.554,213.971Z",
    transform: "translate(-386.055 -207.398)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 6.719,
    cy: 3.879,
    rx: 6.719,
    ry: 3.879,
    transform: "translate(14.439 8.23) rotate(-0.599)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 6.719,
    cy: 3.879,
    rx: 6.719,
    ry: 3.879,
    transform: "translate(28.918 16.389) rotate(-0.599)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1497.534 518.195)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M397.669,276.99l-57.747-33.673-3.623,2.071,57.747,33.673Z",
    transform: "translate(-336.299 -234.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.844,260.756l-40.31-23.505-3.623,2.071,40.31,23.505Z",
    transform: "translate(-331.084 -237.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M380.1,260.619l-34.873-20.335-3.623,2.071,34.873,20.335Z",
    transform: "translate(-333.692 -235.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M389.693,266.212l-17.436-10.167-3.623,2.071,17.436,10.168Z",
    transform: "translate(-320.41 -228.015)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1632.321 438.885)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M488.044,223.812,430.3,190.139l-3.622,2.071,57.747,33.673Z",
    transform: "translate(-426.675 -181.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M481.22,207.578l-40.31-23.505-3.622,2.071,40.31,23.505Z",
    transform: "translate(-421.46 -184.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M470.477,207.441,435.6,187.106l-3.623,2.071,34.873,20.335Z",
    transform: "translate(-424.067 -182.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M480.068,213.034l-17.436-10.168-3.623,2.071L476.446,215.1Z",
    transform: "translate(-410.785 -174.837)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1573.428 330.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M448.566,159.69c-.246-.151-.5-.3-.753-.434l-.045-.027h-.006c-5.788-3.1-13.652-2.534-22.309,2.464l-16.614,9.593,23.354,13.482a2.616,2.616,0,0,0,2.907.116l0,0,28.475-16.528Z",
    transform: "translate(-376.547 -88.68)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M475.535,157.294l-7.5-4.328,27.636-15.955c1.3-.753,1.3-1.979,0-2.734l-28.232-16.3a5.241,5.241,0,0,0-4.734,0l-27.637,15.957-7.494-4.328,27.636-15.955c5.438-3.141,14.286-3.141,19.725,0l28.232,16.3c5.438,3.139,5.438,8.249,0,11.388Z",
    transform: "translate(-427.577 -111.295)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.948)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M506.994,156.581c0-4.007-2.436-8.662-5.441-10.4l-50.071-28.908a3.493,3.493,0,0,0-3.526-.3h0l-59.784,34.739,57.814,43.565,58.9-34.186a2.718,2.718,0,0,0,.521-.3h0C506.385,160.044,506.994,158.583,506.994,156.581Z",
    transform: "translate(-386.704 -116.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M429.437,184.02l58.9-34.186a2.715,2.715,0,0,0,.521-.3h0c.983-.744,1.591-2.206,1.591-4.207a13.352,13.352,0,0,0-1.466-5.791L421.841,178.3Z",
    transform: "translate(-370.158 -105.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M442.7,183.779l-50.071-28.908c-3.005-1.736-5.442-6.391-5.442-10.4h0c0-4.007,2.437-5.848,5.442-4.113L442.7,169.268c3.005,1.736,5.442,6.391,5.442,10.4h0C448.142,183.674,445.705,185.514,442.7,183.779Z",
    transform: "translate(-387.187 -105.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M442.5,169.084l-50.071-28.909a3.456,3.456,0,0,0-3.6-.254,3.781,3.781,0,0,1,3,.528l50.071,28.908c3.005,1.736,5.442,6.391,5.442,10.4h0c0,2.164-.716,3.69-1.843,4.368,1.472-.449,2.446-2.113,2.446-4.643h0C447.939,175.473,445.5,170.818,442.5,169.084Z",
    transform: "translate(-386.381 -105.371)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M421.721,164.861l-6.019-3.472a2.6,2.6,0,0,1-1.084-2.073h0c0-.8.485-1.166,1.084-.82l6.019,3.473a2.6,2.6,0,0,1,1.086,2.072h0C422.806,164.84,422.32,165.207,421.721,164.861Z",
    transform: "translate(-373.708 -88.165)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.796 31.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M426.571,136.669c1.817-1.074,1.8-2.784-.04-3.819a7.314,7.314,0,0,0-6.616.069c-1.817,1.075-1.8,2.784.04,3.821A7.314,7.314,0,0,0,426.571,136.669Z",
    transform: "translate(-418.564 -132.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M433.331,140.479c1.817-1.074,1.8-2.784-.04-3.821a7.314,7.314,0,0,0-6.616.07c-1.815,1.074-1.8,2.783.04,3.82A7.314,7.314,0,0,0,433.331,140.479Z",
    transform: "translate(-415.242 -130.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M440.091,144.288c1.816-1.074,1.8-2.784-.039-3.819a7.313,7.313,0,0,0-6.617.069c-1.815,1.074-1.8,2.784.04,3.82A7.31,7.31,0,0,0,440.091,144.288Z",
    transform: "translate(-411.92 -128.349)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1532.462 554.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M386.8,376.924,543.838,286.2c3.808-2.2,3.33-6.037-1.066-8.576h0c-4.4-2.537-11.045-2.813-14.853-.614L370.886,367.734c-3.806,2.2-3.329,6.037,1.066,8.576h0C376.349,378.846,383,379.122,386.8,376.924Z",
    transform: "translate(-355.494 -254.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M497.577,261.985h0a.6.6,0,0,0-.646-.291l-8.361,1.726,3.23,5.623,5.7-6.353A.6.6,0,0,0,497.577,261.985Z",
    transform: "translate(-296.4 -261.681)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.362 0.867)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M502.67,265.789a4.17,4.17,0,0,0-1.881-3.272,1.364,1.364,0,0,0-1.25-.167,53.268,53.268,0,0,0-27.506,7.074l-.605.348L481.614,287.5l3.081-2a53.281,53.281,0,0,0,16.155-16.423l1.332-2.125A1.369,1.369,0,0,0,502.67,265.789Z",
    transform: "translate(-405.186 -262.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M484.444,280.51a15.981,15.981,0,0,0-7.2-12.538c-3.988-2.313-7.229-.452-7.239,4.16a15.981,15.981,0,0,0,7.2,12.537C481.193,286.981,484.435,285.12,484.444,280.51Z",
    transform: "translate(-405.887 -259.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M440.735,322.734l61.878-37.706L492.425,267.3,428.7,301.782Z",
    transform: "translate(-426.184 -259.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M444.077,306.031c.012-5.448-3.8-12.08-8.511-14.814s-8.543-.534-8.553,4.914,3.8,12.08,8.511,14.814S444.066,311.48,444.077,306.031Z",
    transform: "translate(-427.012 -248.612)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.998 44.325)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M441.711,307.39c.012-5.448-3.8-12.08-8.512-14.814s-8.543-.534-8.553,4.914,3.8,12.08,8.512,14.814S441.7,312.838,441.711,307.39Z",
    transform: "translate(-342.811 -291.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 94.381,
    height: 24.163,
    transform: "translate(2.513 47.583) rotate(-29.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M386.84,338.917c.012-5.447-3.8-12.08-8.511-14.814s-8.543-.534-8.553,4.914,3.8,12.081,8.511,14.816S386.829,344.367,386.84,338.917Z",
    transform: "translate(-369.775 -275.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M382.783,335.7c-.157-3.219-2.735-7.25-5.761-9.005s-5.353-.57-5.2,2.647,2.735,7.248,5.761,9S382.938,338.914,382.783,335.7Z",
    transform: "translate(-368.771 -274.458)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.347 40.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M443.345,306.152c.012-5.447-3.8-12.08-8.512-14.814a6.672,6.672,0,0,0-5.068-1c1.554-1.593,4.081-1.758,6.937-.1,4.711,2.734,8.523,9.367,8.512,14.814-.006,3.254-1.381,5.338-3.487,5.915A6.744,6.744,0,0,0,443.345,306.152Z",
    transform: "translate(-421.644 -289.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M445.193,305.791c.012-5.448-3.8-12.08-8.511-14.814-2.356-1.368-4.492-1.5-6.04-.61L426,293.031l2.16,3.758a19.288,19.288,0,0,0,7.72,13.433l2.16,3.76,4.637-2.665h0C444.228,310.428,445.189,308.516,445.193,305.791Z",
    transform: "translate(-423.492 -288.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M441.385,307.579c.012-5.448-3.8-12.08-8.511-14.816s-8.543-.534-8.553,4.914,3.8,12.082,8.511,14.816S441.374,313.027,441.385,307.579Z",
    transform: "translate(-424.32 -287.829)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 98.659)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M384.875,337.036,379.68,328l-17.345,9.966a5.212,5.212,0,0,0-1.922,7.117h0A5.212,5.212,0,0,0,367.528,347Z",
    transform: "translate(-359.719 -327.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M379.739,334.732a8.147,8.147,0,0,0-3.673-6.392c-2.033-1.18-3.685-.23-3.69,2.121a8.145,8.145,0,0,0,3.672,6.392C378.082,338.033,379.733,337.083,379.739,334.732Z",
    transform: "translate(-353.499 -327.833)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.32 48.574)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M398.086,319.7l-2.571-1.493c-1.476-.856-3.444-.665-5.538.538l-8.913,5.121a6.737,6.737,0,0,0-3.059,5.272l-.01,4.435a3.637,3.637,0,0,1-.913,2.219l.31,2.058-2.2-1.287.006,0a1.138,1.138,0,0,1-.518-1.084l.01-4.437a14.067,14.067,0,0,1,6.377-10.993l8.913-5.121c2.978-1.711,5.776-1.982,7.878-.764l2.57,1.493c1.478.856,3.444.665,5.539-.538L441.9,294.473a1.152,1.152,0,0,1,1.181-.1v0l2.192,1.286-1.9.707a3.647,3.647,0,0,1-1.487,1.933l-35.93,20.644C402.983,320.647,400.186,320.919,398.086,319.7Z",
    transform: "translate(-374.684 -294.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M397.006,319.082c-1.477-.856-3.444-.665-5.538.537l-8.913,5.121a6.746,6.746,0,0,0-3.059,5.274l-.009,4.435a3.657,3.657,0,0,1-1.66,2.861c-.914.525-1.654.1-1.651-.957l.009-4.437a14.062,14.062,0,0,1,6.377-10.993l8.914-5.121c2.977-1.711,5.775-1.982,7.876-.764l2.571,1.493c1.477.856,3.444.665,5.538-.538l35.93-20.644c.914-.525,1.654-.1,1.651.959a3.651,3.651,0,0,1-1.658,2.861l-35.93,20.644c-2.98,1.711-5.776,1.982-7.878.764Z",
    transform: "translate(-373.95 -293.822)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.403 35.804)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M378.331,319.377l-.009,4.436c0,.028-.013.06-.015.089a2.883,2.883,0,0,0,.134-.82l.009-4.435c0-.127.021-.26.033-.388A5.014,5.014,0,0,0,378.331,319.377Z",
    transform: "translate(-378.307 -318.258)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M370.214,353.333l16.429-9.484c1.981-1.144,1.732-3.142-.556-4.464h0c-2.286-1.32-5.748-1.463-7.728-.321l-16.428,9.485c-1.982,1.144-1.733,3.142.555,4.462h0C364.773,354.334,368.234,354.477,370.214,353.333Z",
    transform: "translate(-359.289 -224.033)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M257.249,339.837l-20.526-11.851,20.526-11.851,20.526,11.851Z",
    transform: "translate(1112.302 319.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M271.012,322.877l-20.526,11.851v-23.7l20.526-11.851Z",
    transform: "translate(1119.066 311.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M257.249,314.931,236.723,303.08l20.526-11.851,20.526,11.851Z",
    transform: "translate(1112.302 307.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M257.249,334.728l-20.526-11.851v-23.7l20.526,11.851Z",
    transform: "translate(1112.302 311.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M219.339,244.466l-22.863-13.2,22.863-13.2,22.863,13.2Z",
    transform: "translate(1092.524 271.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M234.669,225.575l-22.863,13.2v-26.4l22.863-13.2Z",
    transform: "translate(1100.058 262.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M219.339,216.725l-22.863-13.2,22.863-13.2,22.863,13.2Z",
    transform: "translate(1092.524 257.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M219.339,238.775l-22.863-13.2v-26.4l22.863,13.2Z",
    transform: "translate(1092.524 262.233)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1732.812 379.948)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M541.741,225.531l-45.789-26.437c-2.81-1.623-2.458-4.456.787-6.33l44.213-25.527c3.245-1.873,8.153-2.076,10.963-.455L597.7,193.219c2.81,1.623,2.458,4.456-.787,6.33L552.7,225.076C549.459,226.949,544.551,227.152,541.741,225.531Z",
    transform: "translate(-494.055 -134.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M599.584,183.48h0v-15.8l-35.425-.019-12.246-7.071c-2.81-1.623-7.718-1.418-10.963.455l-11.424,6.6-35.458-.021v16.249a3.179,3.179,0,0,0,1.882,2.938l45.789,26.435c2.81,1.623,7.718,1.42,10.963-.455l44.213-25.525C598.786,186.183,599.69,184.784,599.584,183.48Z",
    transform: "translate(-494.052 -137.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M546.826,159.5a12.644,12.644,0,0,0-5.876,1.542l-11.424,6.6-35.458-.021v16.249a3.179,3.179,0,0,0,1.882,2.938l45.789,26.435a9.916,9.916,0,0,0,5.087,1.087Z",
    transform: "translate(-494.052 -137.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M498.079,164.948l-4.012,0v16.249a3.179,3.179,0,0,0,1.882,2.938l2.13,1.229Z",
    transform: "translate(-494.052 -134.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.5,201.879a12.5,12.5,0,0,0,8.763-.1V183.33H526.5Z",
    transform: "translate(-478.11 -125.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M541.741,204.4l-45.789-26.437c-2.81-1.623-2.458-4.456.787-6.329l44.213-25.525c3.245-1.875,8.153-2.078,10.963-.455L597.7,172.086c2.81,1.623,2.458,4.456-.787,6.331L552.7,203.943C549.459,205.816,544.551,206.02,541.741,204.4Z",
    transform: "translate(-494.055 -144.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M596.917,165.826,552.7,191.352c-3.245,1.875-8.153,2.078-10.963.455l-45.789-26.435a4.228,4.228,0,0,1-1.4-1.245c-.965,1.554-.528,3.239,1.4,4.353l45.789,26.437c2.81,1.623,7.718,1.418,10.963-.455l44.213-25.525c2.522-1.456,3.287-3.49,2.189-5.086A6.117,6.117,0,0,1,596.917,165.826Z",
    transform: "translate(-494.055 -135.074)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.992 42.246)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M554.742,178.809a4.086,4.086,0,0,1-1.849,3.2c-1.021.591-1.849.112-1.849-1.066a4.087,4.087,0,0,1,1.849-3.2C553.914,177.151,554.742,177.629,554.742,178.809Z",
    transform: "translate(-551.043 -170.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M558.731,176.505a4.086,4.086,0,0,1-1.849,3.2c-1.02.589-1.849.112-1.849-1.068a4.092,4.092,0,0,1,1.849-3.2C557.9,174.848,558.731,175.325,558.731,176.505Z",
    transform: "translate(-549.083 -171.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M562.721,174.2a4.089,4.089,0,0,1-1.849,3.2c-1.022.589-1.849.11-1.849-1.068a4.086,4.086,0,0,1,1.849-3.2C561.893,172.544,562.721,173.022,562.721,174.2Z",
    transform: "translate(-547.122 -172.881)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.079 15.449)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M535.2,182.917l-21.427-12.37c-1.314-.759-1.15-2.086.368-2.963l20.69-11.945a5.7,5.7,0,0,1,5.13-.212l21.427,12.37c1.314.759,1.15,2.086-.368,2.963L540.327,182.7A5.7,5.7,0,0,1,535.2,182.917Z",
    transform: "translate(-512.882 -154.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M530.237,168.021l-2.965-1.711c-.182-.106-.16-.289.051-.41l2.862-1.653a.788.788,0,0,1,.71-.03l2.965,1.712c.182.1.16.288-.051.409l-2.862,1.654A.788.788,0,0,1,530.237,168.021Z",
    transform: "translate(-505.871 -150.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M513.769,170.547l.061.034c.1-.072.192-.145.307-.212l20.69-11.945a5.7,5.7,0,0,1,5.13-.213l21.366,12.337c1.213-.868,1.275-2.049.061-2.752l-21.427-12.37a5.7,5.7,0,0,0-5.13.212l-20.69,11.945C512.619,168.46,512.455,169.788,513.769,170.547Z",
    transform: "translate(-512.882 -154.914)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartcontract);
export default __webpack_public_path__ + "static/media/smartcontract.c5744cadb0a438fe5356d682ff95adb8.svg";
export { ForwardRef as ReactComponent };